import * as React from 'react'
import { useForm, UseFormGetValues, UseFormSetValue } from 'react-hook-form'
import { SearchConditionRegularLeftNavi as Presenter } from './presenter'

interface IProps {
  sunday?: number
  sunday_work_time_from?: string
  sunday_work_time_to?: string
  sunday_work_time_from_unselected?: number
  sunday_work_time_to_unselected?: number

  monday?: number
  monday_work_time_from?: string
  monday_work_time_to?: string
  monday_work_time_from_unselected?: number
  monday_work_time_to_unselected?: number

  tuesday?: number
  tuesday_work_time_from?: string
  tuesday_work_time_to?: string
  tuesday_work_time_from_unselected?: number
  tuesday_work_time_to_unselected?: number

  wednesday?: number
  wednesday_work_time_from?: string
  wednesday_work_time_to?: string
  wednesday_work_time_from_unselected?: number
  wednesday_work_time_to_unselected?: number

  thursday?: number
  thursday_work_time_from?: string
  thursday_work_time_to?: string
  thursday_work_time_from_unselected?: number
  thursday_work_time_to_unselected?: number

  friday?: number
  friday_work_time_from?: string
  friday_work_time_to?: string
  friday_work_time_from_unselected?: number
  friday_work_time_to_unselected?: number

  saturday?: number
  saturday_work_time_from?: string
  saturday_work_time_to?: string
  saturday_work_time_from_unselected?: number
  saturday_work_time_to_unselected?: number
}

const weeks: WeekType[] = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
]

export const SearchConditionRegularLeftNavi = ({
  sunday,
  sunday_work_time_from,
  sunday_work_time_to,
  sunday_work_time_from_unselected,
  sunday_work_time_to_unselected,
  monday,
  monday_work_time_from,
  monday_work_time_to,
  monday_work_time_from_unselected,
  monday_work_time_to_unselected,
  tuesday,
  tuesday_work_time_from,
  tuesday_work_time_to,
  tuesday_work_time_from_unselected,
  tuesday_work_time_to_unselected,
  wednesday,
  wednesday_work_time_from,
  wednesday_work_time_to,
  wednesday_work_time_from_unselected,
  wednesday_work_time_to_unselected,
  thursday,
  thursday_work_time_from,
  thursday_work_time_to,
  thursday_work_time_from_unselected,
  thursday_work_time_to_unselected,
  friday,
  friday_work_time_from,
  friday_work_time_to,
  friday_work_time_from_unselected,
  friday_work_time_to_unselected,
  saturday,
  saturday_work_time_from,
  saturday_work_time_to,
  saturday_work_time_from_unselected,
  saturday_work_time_to_unselected,
  ...props
}: IProps): JSX.Element => {
  const { register, setValue, getValues, watch } = useForm<ISearchRegularState>(
    {
      defaultValues: {
        regular_search: {
          sunday,
          sunday_work_time_from,
          sunday_work_time_to,
          sunday_work_time_from_unselected,
          sunday_work_time_to_unselected,
          monday,
          monday_work_time_from,
          monday_work_time_to,
          monday_work_time_from_unselected,
          monday_work_time_to_unselected,
          tuesday,
          tuesday_work_time_from,
          tuesday_work_time_to,
          tuesday_work_time_from_unselected,
          tuesday_work_time_to_unselected,
          wednesday,
          wednesday_work_time_from,
          wednesday_work_time_to,
          wednesday_work_time_from_unselected,
          wednesday_work_time_to_unselected,
          thursday,
          thursday_work_time_from,
          thursday_work_time_to,
          thursday_work_time_from_unselected,
          thursday_work_time_to_unselected,
          friday,
          friday_work_time_from,
          friday_work_time_to,
          friday_work_time_from_unselected,
          friday_work_time_to_unselected,
          saturday,
          saturday_work_time_from,
          saturday_work_time_to,
          saturday_work_time_from_unselected,
          saturday_work_time_to_unselected,
        },
      },
    },
  )

  const setWeekHandler = (week: WeekType, value: number) => {
    if (!weeks.includes(week)) {
      return
    }
    setValue(`regular_search.${week}`, value)
  }

  const setWorkTimeFromHandler = (week: WeekType, value: string) => {
    setValue(`regular_search.${week}_work_time_from`, value)
  }

  const setWorkTimeFromUnselectedHandler = (week: WeekType, value: number) => {
    if (!weeks.includes(week)) {
      return
    }
    setValue(`regular_search.${week}_work_time_from_unselected`, value)
  }

  const setWorkTimeToHandler = (week: WeekType, value: string) => {
    setValue(`regular_search.${week}_work_time_to`, value)
  }

  const setWorkTimeToUnselectedHandler = (week: WeekType, value: number) => {
    if (!weeks.includes(week)) {
      return
    }
    setValue(`regular_search.${week}_work_time_to_unselected`, value)
  }

  const isSearchDisable = () => {
    return weeks.some((week: WeekType) => {
      const work = watch(`regular_search.${week}`)
      const workTimeFrom = watch(`regular_search.${week}_work_time_from`)
      const workTimeTo = watch(`regular_search.${week}_work_time_to`)
      const workTimeFromUnselected = watch(
        `regular_search.${week}_work_time_from_unselected`,
      )
      const workTimeToUnselected = watch(
        `regular_search.${week}_work_time_to_unselected`,
      )
      if (
        !!work &&
        workTimeFrom >= workTimeTo &&
        !workTimeFromUnselected &&
        !workTimeToUnselected
      ) {
        return true
      }
      return false
    })
  }

  return (
    <Presenter
      {...props}
      weeks={weeks}
      watch={watch}
      setWeekHandler={setWeekHandler}
      setWorkTimeFromHandler={setWorkTimeFromHandler}
      setWorkTimeFromUnselectedHandler={setWorkTimeFromUnselectedHandler}
      setWorkTimeToHandler={setWorkTimeToHandler}
      setWorkTimeToUnselectedHandler={setWorkTimeToUnselectedHandler}
      register={register}
      isSearchDisable={isSearchDisable()}
    />
  )
}

export default SearchConditionRegularLeftNavi
